// Eje 2 — Categoría: quién repara (hoja "Categorías" del xlsx).
// 13 especialidades + OTR, ~80 partidas. Regla de oro: la categoría es
// la CAUSA, no el síntoma ("si mando SÓLO a este subcontratista, ¿se
// termina el problema?"). Un hallazgo = una causa — el daño derivado
// nunca genera observación aparte (spec invariante 11).
//
// Eliminadas respecto de v1 (con razones en el xlsx): ENV (hipótesis
// causal no observable), COM (era el eje Ubicación repetido), TER (era
// el eje Tipo de falla repetido), CUB (fusionada en IMP).
//
// OTR: permitida solo con texto libre obligatorio y enrutamiento a la
// cola de revisión (spec invariante 9); una etiqueta libre con ≥20
// apariciones es candidata a partida formal (proceso manual, fuera del
// MVP por §11).
export const ESPECIALIDADES = [
    {
        codigo: "EST",
        nombre: "Obra gruesa y estructura",
        ayuda: "Losas, muros de hormigón, vigas, pilares, escaleras y fundaciones. Si la observación está en la estructura que sostiene, es aquí.",
        partidas: [
            { codigo: "EST-01", nombre: "Losa" },
            { codigo: "EST-02", nombre: "Muro de hormigón" },
            { codigo: "EST-03", nombre: "Viga o pilar" },
            { codigo: "EST-04", nombre: "Escalera" },
            { codigo: "EST-05", nombre: "Fundación / sobrecimiento" },
        ],
    },
    {
        codigo: "TAB",
        nombre: "Tabiquería y cielos",
        ayuda: "Tabiques de yeso-cartón, cielos falsos y molduras. Divisiones y cielos livianos, no muros estructurales.",
        partidas: [
            { codigo: "TAB-01", nombre: "Tabique yeso-cartón" },
            { codigo: "TAB-02", nombre: "Cielo falso" },
            { codigo: "TAB-03", nombre: "Cielo americano" },
            { codigo: "TAB-04", nombre: "Estructura de tabique" },
            { codigo: "TAB-05", nombre: "Cornisa / moldura" },
        ],
    },
    {
        codigo: "REV",
        nombre: "Revestimientos y pintura",
        ayuda: "Pintura, cerámica, papel mural, estuco y otros acabados de muro y cielo. Lo que se ve, no lo que sostiene.",
        partidas: [
            { codigo: "REV-01", nombre: "Pintura interior" },
            { codigo: "REV-02", nombre: "Pintura exterior" },
            { codigo: "REV-03", nombre: "Estuco" },
            { codigo: "REV-04", nombre: "Empaste" },
            { codigo: "REV-05", nombre: "Papel mural" },
            { codigo: "REV-06", nombre: "Cerámica de muro" },
            { codigo: "REV-07", nombre: "Guardapolvo / junquillo" },
        ],
    },
    {
        codigo: "PAV",
        nombre: "Pavimentos",
        ayuda: "Pisos: cerámica, porcelanato, madera, flotante, alfombra y sus guardapolvos. Sólo el piso, no lo que hay debajo.",
        partidas: [
            { codigo: "PAV-01", nombre: "Porcelanato / cerámica" },
            { codigo: "PAV-02", nombre: "Piso flotante" },
            { codigo: "PAV-03", nombre: "Vinílico" },
            { codigo: "PAV-04", nombre: "Alfombra" },
            { codigo: "PAV-05", nombre: "Radier / nivelación" },
            { codigo: "PAV-06", nombre: "Fragüe / junta" },
        ],
    },
    {
        codigo: "PVE",
        nombre: "Puertas y ventanas",
        ayuda: "Puertas, ventanas, marcos, quincallería y cierres. Incluye vidrios y sellos de la ventana, no la filtración del muro.",
        partidas: [
            { codigo: "PVE-01", nombre: "Hoja de puerta" },
            { codigo: "PVE-02", nombre: "Marco" },
            { codigo: "PVE-03", nombre: "Cristal / termopanel" },
            { codigo: "PVE-04", nombre: "Quincallería" },
            { codigo: "PVE-05", nombre: "Sistema de cierre" },
            { codigo: "PVE-06", nombre: "Sello perimetral de ventana" },
            { codigo: "PVE-07", nombre: "Corredera / riel" },
        ],
    },
    {
        codigo: "MUE",
        nombre: "Muebles",
        ayuda: "Muebles fijos: cocina, closets, vanitorios y sus herrajes. Carpintería incorporada al departamento.",
        partidas: [
            { codigo: "MUE-01", nombre: "Mueble de cocina" },
            { codigo: "MUE-02", nombre: "Closet" },
            { codigo: "MUE-03", nombre: "Vanitorio" },
            { codigo: "MUE-04", nombre: "Cubierta / mesón" },
            { codigo: "MUE-05", nombre: "Bisagras y correderas" },
            { codigo: "MUE-06", nombre: "Tirador / manilla" },
        ],
    },
    {
        codigo: "SAN",
        nombre: "Artefactos y grifería",
        ayuda: "Artefactos y grifería: WC, lavamanos, tina, ducha, llaves y flexibles. El aparato, no la cañería detrás.",
        partidas: [
            { codigo: "SAN-01", nombre: "WC" },
            { codigo: "SAN-02", nombre: "Lavamanos" },
            { codigo: "SAN-03", nombre: "Tina" },
            { codigo: "SAN-04", nombre: "Receptáculo / plato ducha" },
            { codigo: "SAN-05", nombre: "Grifería" },
            { codigo: "SAN-06", nombre: "Accesorios de baño" },
            { codigo: "SAN-07", nombre: "Lavaplatos" },
        ],
    },
    {
        codigo: "INS",
        nombre: "Instalación sanitaria",
        ayuda: "Cañerías de agua y desagües dentro de la unidad. Cuando el origen es la red, no el artefacto que cuelga de ella.",
        partidas: [
            { codigo: "INS-01", nombre: "Agua fría" },
            { codigo: "INS-02", nombre: "Agua caliente" },
            { codigo: "INS-03", nombre: "Alcantarillado" },
            { codigo: "INS-04", nombre: "Aguas lluvia" },
            { codigo: "INS-05", nombre: "Medidor / arranque" },
            { codigo: "INS-06", nombre: "Sifón y desagüe" },
        ],
    },
    {
        codigo: "ELE",
        nombre: "Instalación eléctrica y corrientes débiles",
        ayuda: "Instalación eléctrica y corrientes débiles: enchufes, interruptores, tablero, citófono, TV y datos.",
        partidas: [
            { codigo: "ELE-01", nombre: "Tablero" },
            { codigo: "ELE-02", nombre: "Enchufes" },
            { codigo: "ELE-03", nombre: "Interruptores" },
            { codigo: "ELE-04", nombre: "Luminarias" },
            { codigo: "ELE-05", nombre: "Citófono" },
            { codigo: "ELE-06", nombre: "Datos / TV" },
            { codigo: "ELE-07", nombre: "Timbre" },
            { codigo: "ELE-08", nombre: "Puesta a tierra" },
        ],
    },
    {
        codigo: "GAS",
        nombre: "Instalación de gas",
        ayuda: "Instalación de gas: cañerías, llaves, regulador y conexión de artefactos. Siempre riesgo alto.",
        partidas: [
            { codigo: "GAS-01", nombre: "Red de gas" },
            { codigo: "GAS-02", nombre: "Artefacto a gas" },
            { codigo: "GAS-03", nombre: "Ventilación / evacuación" },
            { codigo: "GAS-04", nombre: "Medidor / regulador" },
            { codigo: "GAS-05", nombre: "Detector" },
        ],
    },
    {
        codigo: "CLI",
        nombre: "Climatización y ventilación",
        ayuda: "Climatización y ventilación: aire acondicionado, calefacción, extractores y ductos.",
        partidas: [
            { codigo: "CLI-01", nombre: "Calefacción" },
            { codigo: "CLI-02", nombre: "Aire acondicionado" },
            { codigo: "CLI-03", nombre: "Extracción baño" },
            { codigo: "CLI-04", nombre: "Extracción cocina / campana" },
            { codigo: "CLI-05", nombre: "Ductos" },
            { codigo: "CLI-06", nombre: "Rejillas" },
        ],
    },
    {
        codigo: "IMP",
        nombre: "Impermeabilización, cubiertas y hojalatería",
        ayuda: "Impermeabilización, cubiertas y hojalatería. Agua que entra desde afuera o desde la losa, no desde una cañería.",
        partidas: [
            { codigo: "IMP-01", nombre: "Impermeabilización de cubierta" },
            { codigo: "IMP-02", nombre: "Techumbre (estructura y cubrimiento)" },
            { codigo: "IMP-03", nombre: "Canal / canaleta" },
            { codigo: "IMP-04", nombre: "Bajada de aguas lluvia" },
            { codigo: "IMP-05", nombre: "Forro / hojalatería" },
            { codigo: "IMP-06", nombre: "Impermeabilización de terraza o balcón" },
            { codigo: "IMP-07", nombre: "Impermeabilización de recinto húmedo" },
            { codigo: "IMP-08", nombre: "Impermeabilización de subterráneo o jardinera" },
            { codigo: "IMP-09", nombre: "Sello de encuentro o junta constructiva" },
        ],
    },
    {
        codigo: "FAC",
        nombre: "Fachada y exteriores",
        ayuda: "Fachada y exteriores: revestimiento exterior, balcones, terrazas, barandas y áreas comunes contiguas.",
        partidas: [
            { codigo: "FAC-01", nombre: "Revestimiento exterior" },
            { codigo: "FAC-02", nombre: "Junta de dilatación" },
            { codigo: "FAC-03", nombre: "Baranda / antepecho" },
            { codigo: "FAC-04", nombre: "Reja / cierre perimetral" },
            { codigo: "FAC-05", nombre: "Celosía / quiebravista" },
            { codigo: "FAC-06", nombre: "Pavimento exterior" },
        ],
    },
    {
        codigo: "OTR",
        nombre: "Otro (requiere texto libre y revisión)",
        ayuda: "Ninguna de las anteriores. Describe la observación con tus palabras y queda en la cola de revisión.",
        partidas: [{ codigo: "OTR-01", nombre: "Sin clasificar" }],
    },
];
//# sourceMappingURL=especialidades.js.map